import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1393c3c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title is-1" }, "Boards", -1))
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Create your Own", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Create ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ml-3 fas fa-caret-square-right" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "column" }
const _hoisted_12 = { class: "box" }
const _hoisted_13 = { class: "level mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "level-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "level-item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Active")
  ])
], -1))
const _hoisted_15 = { class: "level-right" }
const _hoisted_16 = { class: "level-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sort-alpha-down" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Views ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sort-amount-down ml-1" }, null, -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_23 = { class: "columns mb-0 is-mobile" }
const _hoisted_24 = { class: "column v-center-left" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "column m-0 v-center-right" }
const _hoisted_27 = { class: "tag is-success is-medium mr-3" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.board_input) = $event)),
              class: "input",
              type: "text",
              placeholder: "Board Name"
            }, null, 512), [
              [_vModelText, _ctx.board_input]
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoBoard())),
              class: "button mt-3"
            }, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", {
                    class: _normalizeClass('button mr-2 ' + (_ctx.sort_type == 'alpha' ? 'is-active' : '')),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('alpha')))
                  }, _hoisted_18, 2),
                  _createElementVNode("span", {
                    class: _normalizeClass('button ' + (_ctx.sort_type == 'views' ? 'is-active' : '')),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort('views')))
                  }, _hoisted_21, 2)
                ])
              ])
            ]),
            _hoisted_22,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.active_pages, (p, index) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("h1", {
                      class: "title is-6 is-clickable m-0",
                      onClick: ($event: any) => (_ctx.gotoBoard(p.path))
                    }, _toDisplayString(p.path), 9, _hoisted_25)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(p.visits) + " views ", 1),
                    _createElementVNode("span", {
                      class: "button",
                      onClick: ($event: any) => (_ctx.gotoBoard(p.path))
                    }, _hoisted_30, 8, _hoisted_28)
                  ])
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}